import { trackGooglePromotionEvent_click } from '../Tracking/GoogleTracking';

declare var dataLayer: any[];

function formatTotalTime(duration: number): string {
    const totalSeconds = Math.round(duration);
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;
    return `${minutes}:${seconds.toString().padStart(2, '0')}`;
}

function pushVideoEvent(eventAction: string, title: string, duration: number): void {
    const eventLabel = `${title}_${formatTotalTime(duration)}`;
    dataLayer.push({
        event: 'event',
        eventCategory: 'video data',
        eventAction: eventAction,
        eventLabel: eventLabel,
    });
    dataLayer.push({
        event: 'econdaEvent',
        ecCustomProperties: {
            Target: ['video data', `${eventAction}/${eventLabel}`, 0, 'd'],
            rqtype: 'hiddenpi',
        },
    });
}

function setupVideoTracking(video: HTMLVideoElement): void {
    const title = video.getAttribute('aria-label') || 'Video';
    let progress25Tracked = false;
    let progress50Tracked = false;

    const trackingEvent = video.dataset.trackingevent;
    if (trackingEvent) {
        video.addEventListener('play', () => trackGooglePromotionEvent_click(trackingEvent), { once: true });
    }

    video.addEventListener('play', () => {
        pushVideoEvent('video_play', title, video.duration || 0);
    });

    video.addEventListener('pause', () => {
        if (!video.ended) {
            pushVideoEvent('video_pause', title, video.duration || 0);
        }
    });

    video.addEventListener('ended', () => {
        pushVideoEvent('video_complete', title, video.duration || 0);
    });

    video.addEventListener('timeupdate', () => {
        if (!video.duration) {
            return;
        }

        const progress = video.currentTime / video.duration;

        if (!progress25Tracked && progress >= 0.25) {
            progress25Tracked = true;
            pushVideoEvent('video_progress_25', title, video.duration);
        }
        if (!progress50Tracked && progress >= 0.5) {
            progress50Tracked = true;
            pushVideoEvent('video_progress_50', title, video.duration);
        }
    });

    video.addEventListener('seeking', () => {
        if (video.currentTime < video.duration * 0.25) progress25Tracked = false;
        if (video.currentTime < video.duration * 0.5) progress50Tracked = false;
    });
}

function setupPlayOverlay(video: HTMLVideoElement): void {
    const container = video.closest('.external-video-player');
    if (!container) return;

    const overlay = container.querySelector<HTMLButtonElement>('.video-play-overlay');
    if (!overlay) return;

    const hideOverlay = () => {
        overlay.classList.add('is-hidden');
        overlay.setAttribute('aria-hidden', 'true');
        overlay.setAttribute('tabindex', '-1');
    };

    const showOverlay = () => {
        overlay.classList.remove('is-hidden');
        overlay.removeAttribute('aria-hidden');
        overlay.removeAttribute('tabindex');
    };

    overlay.addEventListener('click', () => video.play());
    video.addEventListener('play', hideOverlay);
    video.addEventListener('pause', showOverlay);
    video.addEventListener('ended', showOverlay);
}

export function initExternalVideo(): void {
    document.querySelectorAll<HTMLVideoElement>('.external-video-player video').forEach(video => {
        setupVideoTracking(video);
        setupPlayOverlay(video);
    });
}
